<script>
    import TemplateFilter from '../components/Filter/TemplateFilter.svelte';
</script>

<div class="page">
    <div class="submenu">
        <slot name="submenu" />
    </div>
    <div class="header">
        <slot name="header" />
    </div>
    <div class="monit">
        <slot name="monit" />
    </div>
    <div class="content-header">
        <slot name="content-header" />
    </div>
    <div class="content">
        <slot name="content" />
    </div>
    <div class="footer">
        <slot name="footer" />
    </div>
</div>

<style>
    .page {
        display: grid;
        grid-template-rows: min-content min-content min-content min-content 1fr min-content;
        /*grid-template-columns: 1fr;*/
        grid-template-columns: 100%;
        grid-template-areas:
            'monit'
            'submenu'
            'header'
            'content-header'
            'content'
            'footer';
        height: calc(100vh - var(--top-header-height) - var(--bottom-header-height)); /* 104 */
    }
    .submenu {
        grid-area: submenu;
        /*margin-top: 20px;*/
    }
    .monit {
        grid-area: monit;
        position: relative;
        z-index: 900;
        /*display: flex;*/
        /*justify-content: center;*/
        /*align-items: center;*/
        /*font-size: 20px;*/
        /*padding: 20px;*/
        /*background-color: #f0f0f0;*/
    }
    .header {
        grid-area: header;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        padding: 8px 20px 0 20px;
        width: 100%;
        /*flex-wrap: wrap;*/
    }
    .main-header {
        /*opacity: 0.7;*/
        /*color: #0009;*/
        font-size: 22px;
        flex: 1 0 33%;
    }
    .main-search {
        display: flex;
        align-items: center;
        flex: 1 1 1%;
    }
    .content-header {
        grid-area: content-header;
        /*padding: 20px 20px 0 20px;*/
    }
    .content {
        grid-area: content;
        /*overflow-y: auto;*/
        /*padding: 20px 20px 20px 20px;*/
        /*flex: 1 1 auto;*/
        /*!*overflow-y: auto;*!*/
        /*display: flex;*/
        /*flex-direction: column;*/
        /*min-height: 0;*/
        /*overflow: visible;*/
        /*max-height: 70vh;*/
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        /*overflow-y: visible;*/
    }
    .main-buttons {
        display: flex;
        align-items: center;
        margin-left: auto;
        justify-content: flex-end;
        flex: 1 1 33%;
    }
    .footer {
        /*z-index:0; !* changed from 2 *!*/
        grid-area: footer;
        /*box-shadow: 0 0 25px -4px rgba(0,0,0,0.56);*/
        /*border-top: 5px solid #ededed;*/
        /*background-color: #e0e0e0;*/
    }
</style>
